import React from "react";
import {
  MainUsersLiveFramePng,
  MainUsersLiveFrameSparklePng,
} from "../../../assets";
import {
  Image,
  ImageBackground,
  ImageStyle,
  StyleProp,
  Text,
  TextStyle,
  View,
} from "react-native";

const UsersLive = ({
  liveUsersCount = "0",
  badgeStyle = {
    position: "absolute",
    top: "42%",
    right: 16,
    width: 98,
    height: 98,
  },
  sparkleStyle = {
    position: "absolute",
    bottom: 11,
    left: 16,
    width: 90,
    height: 90,
  },
  textStyle = {
    position: "absolute",
    color: "#ffe593",
    fontSize: 20,
    width: 75,
    top: 46,
    right: 12,
    textAlign: "center",
    fontWeight: "bold",
  },
}: {
  liveUsersCount: string;
  badgeStyle?: StyleProp<ImageStyle>;
  sparkleStyle?: StyleProp<ImageStyle>;
  textStyle?: StyleProp<TextStyle>;
}) => {
  return (
    <View
      style={{
        pointerEvents: "none",
        position: "relative",
        width: "100%",
        height: "100%",
      }}
    >
      <ImageBackground source={MainUsersLiveFramePng} style={badgeStyle}>
        {/* <Image source={MainUsersLiveFrameSparklePng} style={sparkleStyle} /> */}

        <Text numberOfLines={1} ellipsizeMode="tail" style={textStyle}>
          {liveUsersCount}
        </Text>
      </ImageBackground>
    </View>
  );
};

export default UsersLive;
